'use client';

import { faGhost } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@pickleballinc/react-ui';
import { trim } from 'lodash';
import { Fragment, useRef, useState } from 'react';

import { StandingsTablesData } from '@/modules/league/details/standings/ClubRating';
import { formatValueForTables } from '@/modules/league/details/standings/formatValueForTables';
import { getConnectDUPRURL } from '@/utils/helpers/getConnectDUPRURL';
export default function IfpRr({ session, players, user }: StandingsTablesData) {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    if (!scrollContainerRef.current) return;

    setIsDragging(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
    scrollContainerRef.current.style.cursor = 'grabbing';
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !scrollContainerRef.current) return;
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = x - startX;
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    if (!scrollContainerRef.current) return;

    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    if (!scrollContainerRef.current) return;
    setIsDragging(false);
  };
  return (
    <div
      className='mt-2 select-text overflow-auto md:ml-4'
      ref={scrollContainerRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
    >
      <div className='vertical-header-cell  inline-flex h-28  w-auto flex-nowrap rounded-t-lg border-x border-t bg-white font-semibold text-gray-900 lg:flex'>
        <div className='inline-flex w-12 shrink-0 items-center px-2 py-3 text-sm font-medium text-gray-900 [transform:rotate(180deg)] [writing-mode:vertical-lr]'>
          Rank
        </div>
        <div className='inline-flex w-72 shrink-0   px-2 py-3 text-sm font-medium' />

        <div className='inline-flex w-14 shrink-0  items-center px-2 py-3 text-sm font-medium [transform:rotate(180deg)] [writing-mode:vertical-lr]'>
          Wins
        </div>
        <div className='inline-flex w-14 shrink-0   items-center px-2 py-3 text-sm font-medium [transform:rotate(180deg)] [writing-mode:vertical-rl]'>
          Losses
        </div>
        <div className='inline-flex w-14 shrink-0  items-center px-2 py-3 text-sm font-medium [transform:rotate(180deg)] [writing-mode:vertical-lr]'>
          Earned
        </div>
        <div className='inline-flex w-14 shrink-0  items-center px-2 py-3 text-sm font-medium [transform:rotate(180deg)] [writing-mode:vertical-lr]'>
          Against
        </div>
        <div className='inline-flex w-24 shrink-0  items-center px-2 py-3 text-sm font-medium [transform:rotate(180deg)] [writing-mode:vertical-lr]'>
          Diff
        </div>
        <div className='inline-flex w-24 shrink-0  items-center px-2 py-3 text-sm font-medium [transform:rotate(180deg)] [writing-mode:vertical-lr]'>
          Diff %
        </div>
      </div>
      <div className='mb-4 inline-flex w-auto flex-col flex-nowrap  border'>
        {players?.map((player, i) => {
          return (
            <Fragment key={`player-row-${i}`}>
              <div
                className={` flex w-full border-y border-gray-300  ${
                  i === 0
                    ? 'bg-moss-300'
                    : i === 1
                      ? `mt-1 bg-moss-200`
                      : i === 2
                        ? `mt-1 bg-moss-100`
                        : i === 3
                          ? `mt-1 bg-moss-50`
                          : i === 4
                            ? `mt-1 bg-moss-25`
                            : `mt-1 bg-gray-50`
                }`}
                key={i}
              >
                <div className='inline-flex w-12 shrink-0 justify-center break-words border-r px-2 py-4 text-sm font-semibold'>
                  <span className='self-center'>{player.CurrentSeedNumber}</span>
                </div>
                <div className='w-72 shrink-0 flex-row break-words border-r px-2 py-4 text-sm font-semibold '>
                  <div>
                    {player.FirstName_1} {player.LastName_1}
                    {session.CountGamesTowardRatings && !player.DUPR1Active ? (
                      <span className='text-xs font-medium text-gray-600'>
                        {user?.pbUuid &&
                        player.UserID_1.toLowerCase() === user?.pbUuid.toLowerCase() ? (
                          <a
                            className='text-primary-500 underline'
                            href={getConnectDUPRURL(
                              player.UserID_1,
                              'l',
                              window.location.href,
                              window.location.href
                            )}
                            aria-label='Link to connect to DUPR'
                          >
                            Connect To DUPR
                          </a>
                        ) : (
                          '(Not Linked to DUPR)'
                        )}
                      </span>
                    ) : null}
                  </div>
                  {player.FirstName_2 !== '' && player.LastName_2 !== '' ? (
                    <>
                      <br />
                      <div>
                        {player.FirstName_2} {player.LastName_2}
                        {session.CountGamesTowardRatings && !player.DUPR2Active ? (
                          <span className='text-xs font-medium text-gray-600'>
                            {user?.pbUuid &&
                            player.UserID_2 &&
                            player.UserID_2.toLowerCase() === user?.pbUuid.toLowerCase() ? (
                              <a
                                className='text-primary-500 underline'
                                href={getConnectDUPRURL(
                                  player.UserID_2,
                                  'l',
                                  window.location.href,
                                  window.location.href
                                )}
                                aria-label='Link to connect to DUPR'
                              >
                                Connect To DUPR
                              </a>
                            ) : (
                              '(Not Linked to DUPR)'
                            )}
                          </span>
                        ) : null}
                        {trim(player.AttendeeSessionID_2).length === 0 ? (
                          <Tooltip placement='top-start'>
                            <Tooltip.Trigger asChild>
                              <FontAwesomeIcon icon={faGhost} className='ml-2  block' />
                            </Tooltip.Trigger>
                            <Tooltip.Content className='w-42 rounded bg-black bg-black/75 p-2 text-sm text-white'>
                              Not Registered
                            </Tooltip.Content>
                          </Tooltip>
                        ) : null}
                      </div>
                    </>
                  ) : null}
                </div>

                <div className='inline-flex w-14 shrink-0 justify-center break-words border-r px-2 py-4 text-sm '>
                  <span className='self-center'>
                    {' '}
                    {player.TotalWins}
                    {player.TotalWins > 0 &&
                    session.IsReadOnlyMode === false &&
                    session.DateCompleteAndLock === null &&
                    player.UseHeadToHeadWins !== false ? (
                      <Tooltip placement='top-end'>
                        <Tooltip.Trigger asChild>
                          <label className='relative -top-4 left-1 inline-flex items-center justify-center rounded-md border border-leagues-500 bg-leagues-500 px-2 text-white'>
                            <span>{player.TeamHeadToHeadWins}</span>
                          </label>
                        </Tooltip.Trigger>
                        <Tooltip.Content className='w-42 rounded bg-black bg-black/75 p-2 text-sm text-white'>
                          Head to head wins within the tied win column.
                        </Tooltip.Content>
                      </Tooltip>
                    ) : null}
                  </span>
                </div>
                <div className='inline-flex w-14 shrink-0 justify-center break-words border-r px-2 py-4 text-sm '>
                  <span className='self-center'>{player.TotalLosses}</span>
                </div>
                <div className='inline-flex w-14 shrink-0 justify-center break-words border-r px-2 py-4 text-sm '>
                  <span className='self-center'>{player.TotalPoints_Earned}</span>
                </div>
                <div className='inline-flex w-14 shrink-0 justify-center break-words border-r px-2 py-4 text-sm '>
                  <span className='self-center'> {player.TotalPoints_Against}</span>
                </div>
                <div className='inline-flex w-24 shrink-0 justify-center break-words border-r px-2 py-4 text-sm '>
                  <span className='self-center'>{player.TotalPoints_Difference_EarnedAgainst}</span>
                </div>
                <div className='inline-flex w-24 shrink-0 justify-center break-words border-r px-2 py-4 text-sm '>
                  <span className='self-center'>
                    {player.TeamPointDifferencePercentage
                      ? formatValueForTables(player.TeamPointDifferencePercentage)
                      : formatValueForTables(
                          player.TotalPoints_Difference_EarnedPossible_Percentage,
                          100
                        )}
                  </span>
                </div>
              </div>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
